/**
 * Render `value` as a double-quoted RoboQL string literal.
 *
 * RoboQL's grammar admits exactly two escapes inside a double-quoted literal,
 * `\"` and `\\`, so those are the only characters escaped; everything else,
 * non-ASCII included, is emitted as is. `JSON.stringify` is not a substitute:
 * it writes control characters as `\n` or `\u0000`, which RoboQL rejects. A
 * value carrying a control character yields a query that fails to parse.
 *
 * The TypeScript twin of `roboto.query.roboql_literal.as_roboql_string_literal`.
 */
export function roboqlStringLiteral(value: string): string {
  // Backslashes first: escaping quotes first would double the backslash each
  // quote escape inserts, which would end the literal early.
  const escaped = value.replaceAll("\\", "\\\\").replaceAll('"', '\\"');
  return `"${escaped}"`;
}
